export default __webpack_public_path__ + "static/colours-black-1280x800-7d234ae7888551f3b376532e113b28e0.jpg";